import * as React from 'react'

import { StyledLoginWrapper } from './LoginWrapper.glamorous'

export type Props = {
  children?: React.ReactNode;
}

export const LoginWrapper: React.SFC<Props> = ({ children }) => {
  return (
    <StyledLoginWrapper>
      {children}
    </StyledLoginWrapper>
  )
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Login/components/LoginWrapper/LoginWrapper.tsx